
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
import api from '@/api/';

export default {
  data() {
    return {
      // 仓库列表相关属性
      storeStatus: false,
      storeList: [],
      selectStore: '', // 选中仓库
      // 商品标签列表
      productTagList: [], // 商品标签列表
      customProductTagList: [], // 这个标签列表包含自定义标签
      // 分拣 light
      state: 0, // 0为初始状态，1为正在打开，2为已经打开，3为打开失败
      socket: null,
      timeLeft: 0,
      shopList: [],
      platformIds: [],
      platformList: []
    };
  },
  methods: {
    getWareHouseIdToName(warehouseId) { // 根绝warehoseId
      let v = this;
      let status = 0;
      if (v.storeList.length === 0) {
        return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000184');
      }
      for (let i = 0; i < v.storeList.length; i++) {
        let item = v.storeList[i];
        if (item.warehouseId === warehouseId) {
          status = 1;
          return item.warehouseName;
        }
        if (i === v.storeList.length - 1 && status === 0) {
          return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000184');
        }
      }
    },

    getCarrierShippingList(carrierId, warehouseId) {
      /**
       * 返回发货物流方式
       * @params carrierId （必需） 物流商id
       * @params warehouseId （必需） 仓库id
       * */
      let v = this;
      return new Promise(resolve => {
        v.axios.get(api.get_enableShippingMethods + '?carrierId=' + carrierId + '&warehouseId=' + warehouseId).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              resolve(data);
            }
          }
        });
      });
    },
  }
};
